import React, { useEffect, useState } from 'react';
import Layout from '../../components/common/pageLayout';
import { v4_mailbox_configuration, v4_mailbox_configure, v4_mailbox_logout } from '../../actions/v4/mailBox';
import Configure from '../../components/MailBox/configure';
import { toast } from 'react-toastify';
import { removeStorage } from '../../utils';
import constant from '../../constant';

const Index = () => {
    const [showLoader, setShowLoader] = useState(false);
    const [data, setData] = useState(null);
    const [showNewForm, setShowNewForm] = useState(false); // 🔸 control new mailbox form

    const onConfigure = (payload) => {
        setShowLoader(true);
        v4_mailbox_configure(payload).then((res) => {
            if (res.status) {
                toast.success(res.result.message || "Mailbox configured successfully");
                removeStorage(constant.keys.mailFolder);
                v4_mailbox_configuration().then((res) => {
                    if (res.status) {
                        setData(res.result);
                        setShowNewForm(false); // 🔸 hide new form after success
                    }
                    setShowLoader(false);
                });
            } else {
                toast.error(res.error || "Configuration failed");
                setShowLoader(false);
            }
        });
    };

    useEffect(() => {
        setShowLoader(true);
        v4_mailbox_configuration().then((res) => {
            if (res.status) {
                setData(res.result);
                if (res.result.length == 0) {
                    setShowNewForm(true)
                }
            }
            setShowLoader(false);
        });
    }, []);

    const onLogout = (id) => {
        setShowLoader(true);
        v4_mailbox_logout(id).then((res) => {
            if (res.status) {
                toast.success(res.result.message || "Logged out successfully");
                v4_mailbox_configuration().then((res) => {
                    if (res.status) {
                        setData(res.result);
                    } else {
                        setData(null);
                    }
                    setShowLoader(false);
                });
            } else {
                toast.error(res.error || "Logging out failed");
                setShowLoader(false);
            }
        });
    };

    const onMicrosoftSSO = () => {
        const azureClientId = process.env.REACT_APP_AZURE_CLIENT_ID;

        if (!azureClientId) {
            toast.error("Microsoft SSO is not configured. Missing Azure client ID.");
            return;
        }

        const baseUrl = window.location.origin; // e.g. https://app.example.com
        const redirectUri = `${baseUrl}/auth/callback`;

        const authUrl =
            `https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize` +
            `?client_id=${azureClientId}` +
            `&response_type=code` +
            `&redirect_uri=${encodeURIComponent(redirectUri)}` +
            `&response_mode=query` +
            `&scope=${encodeURIComponent(
                "openid profile email offline_access Mail.ReadWrite Mail.Send"
            )}`;

        window.location.href = authUrl;
    };
    return (
        <Layout title="Configure Mailbox">
            {/* 🔘 Button to show add mailbox form */}
            <div className="mb-3 d-flex justify-content-end">
                <button
                    className="btn btn-sm btn-success"
                    onClick={() => setShowNewForm(true)}
                    disabled={showNewForm}
                >
                    <i className="fa fa-plus-circle me-1" /> Add New Mailbox
                </button>
            </div>

            {/* 🔁 Show new config form */}
            {!showLoader && showNewForm && (
                <Configure onSubmit={onConfigure}
                    onMicrosoftSSO={onMicrosoftSSO} />

            )}

            {/* 🔁 Existing mailbox configurations */}
            {!showLoader && data &&
                data.map((item) => (
                    <Configure
                        onMicrosoftSSO={onMicrosoftSSO}
                        key={item.ID}
                        data={item}
                        onLogout={() => onLogout(item.ID)}
                    />
                ))
            }
        </Layout>
    );
};

export default Index;
